import { Matrix } from "./types";

function getCol<T>(matrix: Matrix<T>, colIndex: number) {
  return matrix.map((row) => row[colIndex]);
}

export default getCol;
